import React from "react"
import { Box, styled } from "@mui/system"
import Header from "../components/header/header"
import { Footer } from "../components/footer/footer"
import { Typography, Container } from "@mui/material"
import { MuiThemeProvider } from "../theme"
import { Divider } from "@mui/material"
import { Link } from "gatsby"
import "../components/styles/style.css"

const InstaIcon = styled(({ ...htmlProps }) => (
  <svg {...htmlProps} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12.0001 7.1931C9.33996 7.1931 7.19308 9.33998 7.19308 12.0001C7.19308 14.6603 9.33996 16.8072 12.0001 16.8072C14.6603 16.8072 16.8071 14.6603 16.8071 12.0001C16.8071 9.33998 14.6603 7.1931 12.0001 7.1931ZM12.0001 15.1244C10.2798 15.1244 8.87589 13.7204 8.87589 12.0001C8.87589 10.2798 10.2798 8.87592 12.0001 8.87592C13.7204 8.87592 15.1243 10.2798 15.1243 12.0001C15.1243 13.7204 13.7204 15.1244 12.0001 15.1244ZM17.004 5.87592C16.3829 5.87592 15.8814 6.37748 15.8814 6.99857C15.8814 7.61967 16.3829 8.12123 17.004 8.12123C17.6251 8.12123 18.1267 7.62201 18.1267 6.99857C18.1243 6.37514 17.6251 5.87592 17.004 5.87592ZM21.3704 12.0001C21.3704 10.7064 21.3821 9.42435 21.3095 8.13295C21.2368 6.63295 20.8946 5.3017 19.7978 4.20482C18.6986 3.1056 17.3696 2.76576 15.8696 2.6931C14.5759 2.62045 13.2939 2.63217 12.0025 2.63217C10.7087 2.63217 9.42667 2.62045 8.13527 2.6931C6.63527 2.76576 5.30402 3.10795 4.20714 4.20482C3.10792 5.30404 2.76808 6.63295 2.69542 8.13295C2.62277 9.4267 2.63449 10.7087 2.63449 12.0001C2.63449 13.2915 2.62277 14.5759 2.69542 15.8673C2.76808 17.3673 3.11027 18.6986 4.20714 19.7954C5.30636 20.8947 6.63527 21.2345 8.13527 21.3072C9.42902 21.3798 10.711 21.3681 12.0025 21.3681C13.2962 21.3681 14.5782 21.3798 15.8696 21.3072C17.3696 21.2345 18.7009 20.8923 19.7978 19.7954C20.897 18.6962 21.2368 17.3673 21.3095 15.8673C21.3845 14.5759 21.3704 13.2939 21.3704 12.0001ZM19.3079 17.5267C19.1368 17.9533 18.9306 18.272 18.6001 18.6001C18.2696 18.9306 17.9532 19.1369 17.5267 19.3079C16.2939 19.7978 13.3665 19.6876 12.0001 19.6876C10.6337 19.6876 7.70402 19.7978 6.47121 19.3103C6.04464 19.1392 5.72589 18.9329 5.39777 18.6025C5.0673 18.272 4.86105 17.9556 4.68996 17.529C4.20246 16.2939 4.31261 13.3665 4.31261 12.0001C4.31261 10.6337 4.20246 7.70404 4.68996 6.47123C4.86105 6.04467 5.0673 5.72592 5.39777 5.39779C5.72824 5.06967 6.04464 4.86107 6.47121 4.68998C7.70402 4.20248 10.6337 4.31264 12.0001 4.31264C13.3665 4.31264 16.2962 4.20248 17.529 4.68998C17.9556 4.86107 18.2743 5.06732 18.6025 5.39779C18.9329 5.72826 19.1392 6.04467 19.3103 6.47123C19.7978 7.70404 19.6876 10.6337 19.6876 12.0001C19.6876 13.3665 19.7978 16.2939 19.3079 17.5267Z"
      fill="white"
    />
  </svg>
))({
  marginRight: "10px",
})
const DatenschutzPage = () => {
  return (
    <>
      <MuiThemeProvider>
        <Box
          sx={{
            backgroundColor: "#848A7D",
            width: "100%",
            height: "auto",
            color: "white",
            textAlign: "center",
          }}
        >
          <Header />
          <Container>
            <Box
              sx={{
                maxWidth: "1440px",
                margin: "auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: "150px",
                paddingBottom: "80px",
                "@media only screen and (max-width: 767px)": {
                  // paddingLeft: "20px",
                  // paddingRight: "20px",
                },
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "white",
                  fontWeight: "400",
                  fontSize: "50px",
                  lineHeight: "75px",
                  paddingBottom: "10px",
                  "@media screen and (max-width: 767px)": {
                    fontSize: "30px",
                  },
                }}
              >
                Datenschutz
              </Typography>
              <Box
                sx={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  paddingBottom: "20px",
                  maxWidth: "991px ",
                  margin: "auto ",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center !important",
                  "@media screen and (max-width: 991px)": {
                    maxWidth: "100% !important",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    //margin: "auto ",
                  },
                  h5: {
                    color: "white",
                    marginTop: "30px",
                    marginBottom: "10px",
                  },
                  ".para": {
                    fontSize: "16px",
                    maxWidth: "100% !important",
                  },
                  ".subheading": {
                    paddingBottom: "10px !important",
                    textDecoration: "none",
                    margin: "0px",
                  },
                  ".firstHeading": {
                    marginTop: "12px",
                  },
                  span: {
                    textDecoration: "underline",
                  },
                }}
              >
                <h5 className="subheading">Datenschutzerklärung</h5>
                <h5 className="firstHeading">1. Datenschutz auf einen Blick</h5>
                <Typography className="para">
                  {" "}
                  <span>Allgemeine Hinweise</span> Die folgenden Hinweise geben
                  einen einfachen Überblick darüber, was mit Ihren
                  personenbezogenen Daten passiert, wenn Sie diese Website
                  besuchen. Personenbezogene Daten sind alle Daten, mit denen
                  Sie persönlich identifiziert werden können. Ausführliche
                  Informationen zum Thema Datenschutz entnehmen Sie unserer
                  unter diesem Text aufgeführten Datenschutzerklärung.
                  Datenerfassung auf dieser Website Wer ist verantwortlich für
                  die Datenerfassung auf dieser Website? Die
                  <span> Datenverarbeitung auf dieser Website</span> erfolgt
                  durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem
                  Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser
                  Datenschutzerklärung entnehmen. Wie erfassen wir Ihre Daten?
                  Ihre Daten werden zum einen dadurch erhoben, dass Sie uns
                  diese mitteilen. Hierbei kann es sich z. B. um Daten handeln,
                  die Sie in ein Kontaktformular eingeben. Andere Daten werden
                  automatisch oder nach Ihrer Einwilligung beim Besuch der
                  Website durch unsere ITSysteme erfasst. Das sind vor allem
                  technische Daten (z. B. Internetbrowser, Betriebssystem oder
                  Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt
                  automatisch, sobald Sie diese Website betreten. Wofür nutzen
                  wir Ihre Daten? Ein Teil der Daten wird erhoben, um eine
                  fehlerfreie Bereitstellung der Website zu gewährleisten.
                  Andere Daten können zur Analyse Ihres Nutzerverhaltens
                  verwendet werden. Welche Rechte haben Sie bezüglich Ihrer
                  Daten? Sie haben jederzeit das Recht, unentgeltlich Auskunft
                  über Herkunft, Empfänger und Zweck Ihrer gespeicherten
                  personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                  Recht, die Berichtigung oder Löschung dieser Daten zu
                  verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung
                  erteilt haben, können Sie diese Einwilligung jederzeit für die
                  Zukunft widerrufen. Außerdem haben Sie das Recht, unter
                  bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
                  personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
                  ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                  Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können
                  Sie sich jederzeit an uns wenden. Analyse-Tools und Tools von
                  Drittanbietern Beim Besuch dieser Website kann Ihr
                  Surf-Verhalten statistisch ausgewertet werden. Das geschieht
                  vor allem mit sogenannten Analyseprogrammen. Detaillierte
                  Informationen zu diesen Analyseprogrammen finden Sie in der
                  folgenden Datenschutzerklärung.
                </Typography>

                <h5>2. Hosting Externes Hosting </h5>
                <Typography className="para">
                  Diese Website wird bei einem externen Dienstleister gehostet
                  (Hoster). Die personenbezogenen Daten, die auf dieser Website
                  erfasst werden, werden auf den Servern des Hosters
                  gespeichert. Hierbei kann es sich v. a. um IP-Adressen,
                  Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten,
                  Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die
                  über eine Website generiert werden, handeln. Der Einsatz des
                  Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber
                  unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1
                  lit. b DSGVO) und im Interesse einer sicheren, schnellen und
                  effizienten Bereitstellung unseres Online-Angebots durch einen
                  professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO). Sofern
                  eine entsprechende Einwilligung abgefragt wurde, erfolgt die
                  Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1
                  lit. a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung
                  die Speicherung von Cookies oder den Zugriff auf Informationen
                  im Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne
                  des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
                  Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie
                  dies zur Erfüllung seiner Leistungspflichten erforderlich ist
                  und unsere Weisungen in Bezug auf diese Daten befolgen. Wir
                  setzen folgenden Hoster ein: Google Ireland Limited Gordon
                  House, Barrow Street Dublin 4 Irland Auftragsverarbeitung Wir
                  haben einen Vertrag über Auftragsverarbeitung (AVV) mit dem
                  oben genannten Anbieter geschlossen. Hierbei handelt es sich
                  um einen datenschutzrechtlich vorgeschriebenen Vertrag, der
                  gewährleistet, dass dieser die personenbezogenen Daten unserer
                  Websitebesucher nur nach unseren Weisungen und unter
                  Einhaltung der DSGVO verarbeitet.
                </Typography>

                <h5>3. Allgemeine Hinweise und Pflichtinformationen </h5>
                <Typography className="para">
                  Datenschutz Die Betreiber dieser Seiten nehmen den Schutz
                  Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
                  personenbezogenen Daten vertraulich und entsprechend den
                  gesetzlichen Datenschutzvorschriften sowie dieser
                  Datenschutzerklärung. Wenn Sie diese Website benutzen, werden
                  verschiedene personenbezogene Daten erhoben. Personenbezogene
                  Daten sind Daten, mit denen Sie persönlich identifiziert
                  werden können. Die vorliegende Datenschutzerklärung erläutert,
                  welche Daten wir erheben und wofür wir sie nutzen. Sie
                  erläutert auch, wie und zu welchem Zweck das geschieht. Wir
                  weisen darauf hin, dass die Datenübertragung im Internet (z.
                  B. bei der Kommunikation per E-Mail) Sicherheitslücken
                  aufweisen kann. Ein lückenloser Schutz der Daten vor dem
                  Zugriff durch Dritte ist nicht möglich. Hinweis zur
                  verantwortlichen Stelle Die verantwortliche Stelle für die
                  Datenverarbeitung auf dieser Website ist: Six7 House (Pty) Ltd
                  Unit 34B Westlake Lifestyle Centre Westlake Drive Tokai 7945
                  Telefon: +27 (76) 421 2467 E-Mail: katrin.heiss@six7house.com
                  Verantwortliche Stelle ist die natürliche oder juristische
                  Person, die allein oder gemeinsam mit anderen über die Zwecke
                  und Mittel der Verarbeitung von personenbezogenen Daten (z. B.
                  Namen, E-Mail-Adressen o. Ä.) entscheidet. Speicherdauer
                  Soweit innerhalb dieser Datenschutzerklärung keine speziellere
                  Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
                  Daten bei uns, bis der Zweck für die Datenverarbeitung
                  entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend
                  machen oder eine Einwilligung zur Datenverarbeitung
                  widerrufen, werden Ihre Daten gelöscht, sofern wir keine
                  anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
                  personenbezogenen Daten haben (z. B. steuer- oder
                  handelsrechtliche Aufbewahrungsfristen); im letztgenannten
                  Fall erfolgt die Löschung nach Fortfall dieser Gründe.
                  Allgemeine Hinweise zu den Rechtsgrundlagen der
                  Datenverarbeitung auf dieser Website Sofern Sie in die
                  Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre
                  personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a
                  DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
                  Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden.
                  Im Falle einer ausdrücklichen Einwilligung in die Übertragung
                  personenbezogener Daten in Drittstaaten erfolgt die
                  Datenverarbeitung außerdem auf Grundlage von Art. 49 Abs. 1
                  lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder
                  in den Zugriff auf Informationen in Ihr Endgerät (z. B. via
                  Device-Fingerprinting) eingewilligt haben, erfolgt die
                  Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1
                  TTDSG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre
                  Daten zur Vertragserfüllung oder zur Durchführung
                  vorvertraglicher Maßnahmen erforderlich, verarbeiten wir Ihre
                  Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des
                  Weiteren verarbeiten wir Ihre Daten, sofern diese zur
                  Erfüllung einer rechtlichen Verpflichtung erforderlich sind
                  auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die
                  Datenverarbeitung kann ferner auf Grundlage unseres
                  berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO
                  erfolgen. Über die jeweils im Einzelfall einschlägigen
                  Rechtsgrundlagen wird in den folgenden Absätzen dieser
                  Datenschutzerklärung informiert. Hinweis zur Datenweitergabe
                  in die USA und sonstige Drittstaaten Wir verwenden unter
                  anderem Tools von Unternehmen mit Sitz in den USA oder
                  sonstigen datenschutzrechtlich nicht sicheren Drittstaaten.
                  Wenn diese Tools aktiv sind, können Ihre personenbezogene
                  Daten in diese Drittstaaten übertragen und dort verarbeitet
                  werden. Wir weisen darauf hin, dass in diesen Ländern kein mit
                  der EU vergleichbares Datenschutzniveau garantiert werden
                  kann. Beispielsweise sind US-Unternehmen dazu verpflichtet,
                  personenbezogene Daten an Sicherheitsbehörden herauszugeben,
                  ohne dass Sie als Betroffener hiergegen gerichtlich vorgehen
                  könnten. Es kann daher nicht ausgeschlossen werden, dass
                  US-Behörden (z. B. Geheimdienste) Ihre auf US-Servern
                  befindlichen Daten zu Überwachungszwecken verarbeiten,
                  auswerten und dauerhaft speichern. Wir haben auf diese
                  Verarbeitungstätigkeiten keinen Einfluss. Widerruf Ihrer
                  Einwilligung zur Datenverarbeitung Viele
                  Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
                  Einwilligung möglich. Sie können eine bereits erteilte
                  Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis
                  zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
                  unberührt. Widerspruchsrecht gegen die Datenerhebung in
                  besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)
                  WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1
                  LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT,
                  AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN,
                  GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN
                  WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE
                  BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE
                  RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN
                  SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH
                  EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN
                  NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE
                  SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE
                  INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE
                  VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER
                  VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21
                  ABS. 1 DSGVO). WERDEN IHRE PERSONENBEZOGENEN DATEN
                  VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS
                  RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE
                  BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER
                  WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT
                  ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE
                  WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN
                  ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG
                  VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
                  Beschwerderecht bei der zuständigen Aufsichtsbehörde Im Falle
                  von Verstößen gegen die DSGVO steht den Betroffenen ein
                  Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in
                  dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres
                  Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu.
                  Das Beschwerderecht besteht unbeschadet anderweitiger
                  verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
                </Typography>

                <Typography className="para">
                  {" "}
                  Rechtauf Datenübertragbarkeit Sie haben das Recht, Daten, die
                  wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines
                  Vertrags automatisiert verarbeiten, an sich oder an einen
                  Dritten in einem gängigen, maschinenlesbaren Format
                  aushändigen zu lassen. Sofern Sie die direkte Übertragung der
                  Daten an einen anderen Verantwortlichen verlangen, erfolgt
                  dies nur, soweit es technisch machbar ist. Auskunft, Löschung
                  und Berichtigung Sie haben im Rahmen der geltenden
                  gesetzlichen Bestimmungen jederzeit das Recht auf
                  unentgeltliche Auskunft über Ihre gespeicherten
                  personenbezogenen Daten, deren Herkunft und Empfänger und den
                  Zweck der Datenverarbeitung und ggf. ein Recht auf
                  Berichtigung oder Löschung dieser Daten. Hierzu sowie zu
                  weiteren Fragen zum Thema personenbezogene Daten können Sie
                  sich jederzeit an uns wenden. Recht auf Einschränkung der
                  Verarbeitung Sie haben das Recht, die Einschränkung der
                  Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                  Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf
                  Einschränkung der Verarbeitung besteht in folgenden Fällen:
                  Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
                  personenbezogenen Daten bestreiten, benötigen wir in der Regel
                  Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben
                  Sie das Recht, die Einschränkung der Verarbeitung Ihrer
                  personenbezogenen Daten zu verlangen. Wenn die Verarbeitung
                  Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht,
                  können Sie statt der Löschung die Einschränkung der
                  Datenverarbeitung verlangen. Wenn wir Ihre personenbezogenen
                  Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung,
                  Verteidigung oder Geltendmachung von Rechtsansprüchen
                  benötigen, haben Sie das Recht, statt der Löschung die
                  Einschränkung der Verarbeitung Ihrer personenbezogenen Daten
                  zu verlangen. Wenn Sie einen Widerspruch nach Art. 21 Abs. 1
                  DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und
                  unseren Interessen vorgenommen werden. Solange noch nicht
                  feststeht, wessen Interessen überwiegen, haben Sie das Recht,
                  die Einschränkung der Verarbeitung Ihrer personenbezogenen
                  Daten zu verlangen. Wenn Sie die Verarbeitung Ihrer
                  personenbezogenen Daten eingeschränkt haben, dürfen diese
                  Daten – von ihrer Speicherung abgesehen – nur mit Ihrer
                  Einwilligung oder zur Geltendmachung, Ausübung oder
                  Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte
                  einer anderen natürlichen oder juristischen Person oder aus
                  Gründen eines wichtigen öffentlichen Interesses der
                  Europäischen Union oder eines Mitgliedstaats verarbeitet
                  werden. SSL- bzw. TLS-Verschlüsselung Diese Seite nutzt aus
                  Sicherheitsgründen und zum Schutz der Übertragung
                  vertraulicher Inhalte, wie zum Beispiel Bestellungen oder
                  Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-
                  bzw. TLSVerschlüsselung. Eine verschlüsselte Verbindung
                  erkennen Sie daran, dass die Adresszeile des Browsers von
                  „http://“ auf „https://“ wechselt und an dem Schloss-Symbol in
                  Ihrer Browserzeile. Wenn die SSL- bzw. TLS-Verschlüsselung
                  aktiviert ist, können die Daten, die Sie an uns übermitteln,
                  nicht von Dritten mitgelesen werden.
                </Typography>
                <h5> 4. Datenerfassung auf dieser Website</h5>
                <Typography className="para">
                  Cookies Unsere Internetseiten verwenden so genannte „Cookies“.
                  Cookies sind kleine Textdateien und richten auf Ihrem Endgerät
                  keinen Schaden an. Sie werden entweder vorübergehend für die
                  Dauer einer Sitzung (Session-Cookies) oder dauerhaft
                  (permanente Cookies) auf Ihrem Endgerät gespeichert.
                  Session-Cookies werden nach Ende Ihres Besuchs automatisch
                  gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät
                  gespeichert, bis Sie diese selbst löschen oder eine
                  automatische Löschung durch Ihren Webbrowser erfolgt.
                  Teilweise können auch Cookies von Drittunternehmen auf Ihrem
                  Endgerät gespeichert werden, wenn Sie unsere Seite betreten
                  (Third-Party-Cookies). Diese ermöglichen uns oder Ihnen die
                  Nutzung bestimmter Dienstleistungen des Drittunternehmens (z.
                  B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
                  Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind
                  technisch notwendig, da bestimmte Websitefunktionen ohne diese
                  nicht funktionieren würden (z. B. die Warenkorbfunktion oder
                  die Anzeige von Videos). Andere Cookies dienen dazu, das
                  Nutzerverhalten auszuwerten oder Werbung anzuzeigen. Cookies,
                  die zur Durchführung des elektronischen
                  Kommunikationsvorgangs, zur Bereitstellung bestimmter, von
                  Ihnen erwünschter Funktionen (z. B. für die Warenkorbfunktion)
                  oder zur Optimierung der Website (z. B. Cookies zur Messung
                  des Webpublikums) erforderlich sind (notwendige Cookies),
                  werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
                  gespeichert, sofern keine andere Rechtsgrundlage angegeben
                  wird. Der Websitebetreiber hat ein berechtigtes Interesse an
                  der Speicherung von notwendigen Cookies zur technisch
                  fehlerfreien und optimierten Bereitstellung seiner Dienste.
                  Sofern eine Einwilligung zur Speicherung von Cookies und
                  vergleichbaren Wiedererkennungstechnologien abgefragt wurde,
                  erfolgt die Verarbeitung ausschließlich auf Grundlage dieser
                  Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
                  TTDSG); die Einwilligung ist jederzeit widerrufbar. Sie können
                  Ihren Browser so einstellen, dass Sie über das Setzen von
                  Cookies informiert werden und Cookies nur im Einzelfall
                  erlauben, die Annahme von Cookies für bestimmte Fälle oder
                  generell ausschließen sowie das automatische Löschen der
                  Cookies beim Schließen des Browsers aktivieren. Bei der
                  Deaktivierung von Cookies kann die Funktionalität dieser
                  Website eingeschränkt sein. Soweit Cookies von
                  Drittunternehmen oder zu Analysezwecken eingesetzt werden,
                  werden wir Sie hierüber im Rahmen dieser Datenschutzerklärung
                  gesondert informieren und ggf. eine Einwilligung abfragen.
                  Kontaktformular Wenn Sie uns per Kontaktformular Anfragen
                  zukommen lassen, werden Ihre Angaben aus dem Anfrageformular
                  inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
                  Bearbeitung der Anfrage und für den Fall von Anschlussfragen
                  bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre
                  Einwilligung weiter. Die Verarbeitung dieser Daten erfolgt auf
                  Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
                  mit der Erfüllung eines Vertrags zusammenhängt oder zur
                  Durchführung vorvertraglicher Maßnahmen erforderlich ist. In
                  allen übrigen Fällen beruht die Verarbeitung auf unserem
                  berechtigten Interesse an der effektiven Bearbeitung der an
                  uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf
                  Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese
                  abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.
                  Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben
                  bei uns, bis Sie uns zur Löschung auffordern, Ihre
                  Einwilligung zur Speicherung widerrufen oder der Zweck für die
                  Datenspeicherung entfällt (z. B. nach abgeschlossener
                  Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen
                  – insbesondere Aufbewahrungsfristen – bleiben unberührt.
                  Anfrage per E-Mail, Telefon oder Telefax Wenn Sie uns per
                  E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage
                  inklusive aller daraus hervorgehenden personenbezogenen Daten
                  (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei
                  uns gespeichert und verarbeitet. Diese Daten geben wir nicht
                  ohne Ihre Einwilligung weiter. Die Verarbeitung dieser Daten
                  erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern
                  Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt
                  oder zur Durchführung vorvertraglicher Maßnahmen erforderlich
                  ist. In allen übrigen Fällen beruht die Verarbeitung auf
                  unserem berechtigten Interesse an der effektiven Bearbeitung
                  der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO)
                  oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)
                  sofern diese abgefragt wurde; die Einwilligung ist jederzeit
                  widerrufbar. Die von Ihnen an uns per Kontaktanfragen
                  übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung
                  auffordern, Ihre Einwilligung zur Speicherung widerrufen oder
                  der Zweck für die Datenspeicherung entfällt (z. B. nach
                  abgeschlossener Bearbeitung Ihres Anliegens). Zwingende
                  gesetzliche Bestimmungen – insbesondere gesetzliche
                  Aufbewahrungsfristen – bleiben unberührt.
                </Typography>

                <h5>5. Soziale Medien </h5>
                <Typography
                  className="para"
                  sx={{
                    "@media screen and (max-width: 530px)": {
                      maxWidth: "100% !important",
                      //margin: "auto ",
                    },
                  }}
                >
                  {" "}
                  Instagram Auf dieser Website sind Funktionen des Dienstes
                  Instagram eingebunden. Diese Funktionen werden angeboten durch
                  die Meta Platforms Ireland Limited, 4 Grand Canal Square,
                  Grand Canal Harbour, Dublin 2, Irland. Wenn das
                  Social-Media-Element aktiv ist, wird eine direkte Verbindung
                  zwischen Ihrem Endgerät und dem Instagram-Server hergestellt.
                  Instagram erhält dadurch Informationen über den Besuch dieser
                  Website durch Sie. Wenn Sie in Ihrem Instagram-Account
                  eingeloggt sind, können Sie durch Anklicken des
                  Instagram-Buttons die Inhalte dieser Website mit Ihrem
                  Instagram-Profil verlinken. Dadurch kann Instagram den Besuch
                  dieser Website Ihrem Benutzerkonto zuordnen. Wir weisen darauf
                  hin, dass wir als Anbieter der Seiten keine Kenntnis vom
                  Inhalt der übermittelten Daten sowie deren Nutzung durch
                  Instagram erhalten. Soweit eine Einwilligung (Consent)
                  eingeholt wurde, erfolgt der Einsatz des o. g. Dienstes auf
                  Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 TTDSG. Die
                  Einwilligung ist jederzeit widerrufbar. Soweit keine
                  Einwilligung eingeholt wurde, erfolgt die Verwendung des
                  Dienstes auf Grundlage unseres berechtigten Interesses an
                  einer möglichst umfassenden Sichtbarkeit in den Sozialen
                  Medien. Soweit mit Hilfe des hier beschriebenen Tools
                  personenbezogene Daten auf unserer Website erfasst und an
                  Facebook bzw. Instagram weitergeleitet werden, sind wir und
                  die Meta Platforms Ireland Limited, 4 Grand Canal Square,
                  Grand Canal Harbour, Dublin 2, Irland gemeinsam für diese
                  Datenverarbeitung verantwortlich (Art. 26 DSGVO). Die
                  gemeinsame Verantwortlichkeit beschränkt sich dabei
                  ausschließlich auf die Erfassung der Daten und deren
                  Weitergabe an Facebook bzw. Instagram. Die nach der
                  Weiterleitung erfolgende Verarbeitung durch Facebook bzw.
                  Instagram ist nicht Teil der gemeinsamen Verantwortung. Die
                  uns gemeinsam obliegenden Verpflichtungen wurden in einer
                  Vereinbarung über gemeinsame Verarbeitung festgehalten. Den
                  Wortlaut der Vereinbarung finden Sie unter:<br></br>
                  https://www.facebook.com/legal/controller _addendum. Laut
                  dieser Vereinbarung sind wir für die Erteilung der
                  Datenschutzinformationen beim Einsatz des Facebook- bzw.
                  Instagram-Tools und für die datenschutzrechtlich sichere
                  Implementierung des Tools auf unserer Website verantwortlich.
                  Für die Datensicherheit der Facebook bzw. Instagram-Produkte
                  ist Facebook verantwortlich. Betroffenenrechte (z. B.
                  Auskunftsersuchen) hinsichtlich der bei Facebook bzw.
                  Instagram verarbeiteten Daten können Sie direkt bei Facebook
                  geltend machen. Wenn Sie die Betroffenenrechte bei uns geltend
                  machen, sind wir verpflichtet, diese an Facebook
                  weiterzuleiten. Die Datenübertragung in die USA wird auf die
                  Standardvertragsklauseln der EU-Kommission gestützt. Details
                  finden Sie hier : https://www.facebook.com/legal/EU_
                  data_transfer _addendum
                  <br></br>
                  https://help.instagram.com/5195221 25107875 und
                  <br></br>
                  https://de-de.facebook.com/help/566994660333381. Weitere
                  Informationen hierzu finden Sie in der Datenschutzerklärung
                  von Instagram: https://instagram.com/about/legal /privacy/.{" "}
                </Typography>

                <h5>6. Newsletter </h5>
                <Typography className="para">
                  {" "}
                  Newsletterdaten Wenn Sie den auf der Website angebotenen
                  Newsletter beziehen möchten, benötigen wir von Ihnen eine
                  EMail- Adresse sowie Informationen, welche uns die Überprüfung
                  gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse
                  sind und mit dem Empfang des Newsletters einverstanden sind.
                  Weitere Daten werden nicht bzw. nur auf freiwilliger Basis
                  erhoben. Diese Daten verwenden wir ausschließlich für den
                  Versand der angeforderten Informationen und geben diese nicht
                  an Dritte weiter. Die Verarbeitung der in das
                  Newsletteranmeldeformular eingegebenen Daten erfolgt
                  ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1
                  lit. a DSGVO). Die erteilte Einwilligung zur Speicherung der
                  Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des
                  Newsletters können Sie jederzeit widerrufen, etwa über den
                  „Austragen“-Link im Newsletter. Die Rechtmäßigkeit der bereits
                  erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf
                  unberührt. Die von Ihnen zum Zwecke des Newsletter-Bezugs bei
                  uns hinterlegten Daten werden von uns bis zu Ihrer Austragung
                  aus dem Newsletter bei uns bzw. dem Newsletterdiensteanbieter
                  gespeichert und nach der Abbestellung des Newsletters oder
                  nach Zweckfortfall aus der Newsletterverteilerliste gelöscht.
                  Wir behalten uns vor, E-Mail-Adressen aus unserem
                  Newsletterverteiler nach eigenem Ermessen im Rahmen unseres
                  berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO zu
                  löschen oder zu sperren. Daten, die zu anderen Zwecken bei uns
                  gespeichert wurden, bleiben hiervon unberührt. Nach Ihrer
                  Austragung aus der Newsletterverteilerliste wird Ihre
                  E-Mail-Adresse bei uns bzw. dem Newsletterdiensteanbieter ggf.
                  in einer Blacklist gespeichert, sofern dies zur Verhinderung
                  künftiger Mailings erforderlich ist. Die Daten aus der
                  Blacklist werden nur für diesen Zweck verwendet und nicht mit
                  anderen Daten zusammengeführt. Dies dient sowohl Ihrem
                  Interesse als auch unserem Interesse an der Einhaltung der
                  gesetzlichen Vorgaben beim Versand von Newslettern
                  (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f
                  DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht
                  befristet. Sie können der Speicherung widersprechen, sofern
                  Ihre Interessen unser berechtigtes Interesse überwiegen.{" "}
                </Typography>
                <h5>7. Plugins und Tools </h5>
                <Typography className="para">
                  YouTube mit erweitertem Datenschutz Diese Website bindet
                  Videos der YouTube ein. Betreiber der Seiten ist die Google
                  Ireland Limited („Google“), Gordon House, Barrow Street,
                  Dublin 4, Irland. Wir nutzen YouTube im erweiterten
                  Datenschutzmodus. Dieser Modus bewirkt laut YouTube, dass
                  YouTube keine Informationen über die Besucher auf dieser
                  Website speichert, bevor diese sich das Video ansehen. Die
                  Weitergabe von Daten an YouTube-Partner wird durch den
                  erweiterten Datenschutzmodus hingegen nicht zwingend
                  ausgeschlossen. So stellt YouTube – unabhängig davon, ob Sie
                  sich ein Video ansehen – eine Verbindung zum Google
                  DoubleClick-Netzwerk her. Sobald Sie ein YouTube-Video auf
                  dieser Website starten, wird eine Verbindung zu den Servern
                  von YouTube hergestellt. Dabei wird dem YouTube-Server
                  mitgeteilt, welche unserer Seiten Sie besucht haben.Wenn Sie
                  in Ihrem YouTube-Account eingeloggt sind, ermöglichen Sie
                  YouTube, Ihr Surfverhalten direkt Ihrem persönlichen Profil
                  zuzuordnen. Dies können Sie verhindern, indem Sie sich aus
                  Ihrem YouTube- Account ausloggen. Des Weiteren kann YouTube
                  nach Starten eines Videos verschiedene Cookies auf Ihrem
                  Endgerät speichern oder vergleichbare
                  Wiedererkennungstechnologien (z. B. Device-Fingerprinting)
                  einsetzen. Auf diese Weise kann YouTube Informationen über
                  Besucher dieser Website erhalten. Diese Informationen werden
                  u. a. verwendet, um Videostatistiken zu erfassen, die
                  Anwenderfreundlichkeit zu verbessern und Betrugsversuchen
                  vorzubeugen. Gegebenenfalls können nach dem Start eines
                  YouTube-Videos weitere Datenverarbeitungsvorgänge ausgelöst
                  werden, auf die wir keinen Einfluss haben. Die Nutzung von
                  YouTube erfolgt im Interesse einer ansprechenden Darstellung
                  unserer Online-Angebote. Dies stellt ein berechtigtes
                  Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Sofern
                  eine entsprechende Einwilligung abgefragt wurde, erfolgt die
                  Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1
                  lit. a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung
                  die Speicherung von Cookies oder den Zugriff auf Informationen
                  im Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne
                  des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
                  Weitere Informationen über Datenschutz bei YouTube finden Sie
                  in deren Datenschutzerklärung unter:
                  https://policies.google.com/privacy?hl=de. Quelle:
                  https://www.e-recht24.de 11
                </Typography>
              </Box>
            </Box>
            <Divider
              sx={{
                //margin: "0 -100px",
                borderColor: "#B4B4B4",
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "41px",
                "@media screen and (max-width: 767px)": {
                  justifyContent: "center",
                  padding: "41px  15px",
                },
                a: {
                  color: "#FFFFFF",
                },
                ul: {
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  columnGap: "25px",
                  "@media screen and (max-width: 600px)": {
                    flexWrap: "wrap",
                    justifyContent: "center",
                  },
                  "@media screen and (max-width: 435px)": {
                    columnGap: "20px",
                  },
                  li: {
                    marginRight: "25px",
                    position: "relative",
                    color: "#EDEDEC",
                    "@media screen and (max-width: 991px)": {
                      margin: "auto",
                      color: "#FFFFFF",
                    },
                    "@media screen and (max-width: 600px)": {
                      mr: "0px",
                      fontSize: "12px",
                    },
                    "@media screen and (max-width: 435px)": {
                      margin: "0px",
                      fontSize: "8px",
                    },
                    "&:not(:first-of-type):before": {
                      content: '""',
                      width: "4px",
                      height: "4px",
                      position: "absolute",
                      left: -25,
                      background: "#FFFFFF",
                      top: 0,
                      bottom: 0,
                      margin: "auto",
                      borderRadius: "50%",
                      "@media screen and (max-width: 991px)": {
                        left: -13,
                      },
                    },
                    ":last-child": {
                      mr: 0,
                    },
                  },
                },
                ".follow-us-link": {
                  "@media screen and (max-width: 767px)": {
                    display: "none",
                  },
                },
              }}
            >
              <ul>
                <li>© 2022 six7house, Inc. </li>
                <li>
                  <Link to="/impressum/">Impressum</Link>{" "}
                </li>
                <li>
                  <Link to="/datenschutz/">Datenschutz</Link>{" "}
                </li>
                <li>
                  <Link to="/agb/">AGB’s</Link>{" "}
                </li>
              </ul>
              <Link
                to="https://www.instagram.com/six7house/"
                className="follow-us-link"
                target="_blank"
              >
                <InstaIcon /> Follow us!
              </Link>
            </Box>
          </Container>
        </Box>
      </MuiThemeProvider>
    </>
  )
}

export default DatenschutzPage
